import React from 'react';
import { ContentHolderWrapper } from './contentHolder.style';

export default props => (
  <ContentHolderWrapper id={props.id && props.id}  className={`isoExampleWrapper ${props.className ? props.className : ''}`} style={props.style}>
    {props.children}
  </ContentHolderWrapper>
);